import React from 'react';
import PropTypes from 'prop-types';

import { Icon, Skeleton } from 'modules/Core/Common';
import * as S from './HeaderCategoryInfo.styles';
import i18n from 'i18next';

const HeaderCategoryInfo = ({ loading, category, gradingLink }) => {
  if (loading) {
    return (
      <S.InfoWrapper>
        <S.InfoContainer>
          <div className="primary">
            <Skeleton type="string" />
            <Skeleton type="string" />
          </div>
          <div className="secondary">
            <Skeleton type="string" />
            <Skeleton type="string" />
          </div>
        </S.InfoContainer>
      </S.InfoWrapper>
    );
  }

  return (
    <S.Container>
      <S.Info>
        <div>
          <span>{i18n.t('commons.header-category-info.category')}</span>
          <strong>{category}</strong>
        </div>
        <S.GradingContainer>
          <span>{i18n.t('commons.header-category-info.grading-rubric')}</span>
          <a href={gradingLink} target="_blank" rel="noreferrer">
            <Icon name="url" />
          </a>
        </S.GradingContainer>
      </S.Info>
    </S.Container>
  );
};

HeaderCategoryInfo.propTypes = {
  loading: PropTypes.bool,
  category: PropTypes.string,
  gradingLink: PropTypes.string,
};

export default HeaderCategoryInfo;
